import { Typography } from "@mui/material";
import React from "react";

const EmptyList = ({text}) => {
  return <Typography>{text}</Typography>;
};

export default EmptyList;
